/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/features/graph/graph_helpers.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { _jac } from "@jac/prelude";
function kind_title(kind) {
  let titles = {"Incident": "Incident", "Person": "People", "IdentityDecision": "Identity reviews", "Claim": "Claims", "Source": "Sources", "Organization": "Organizations", "Alert": "Alerts", "Subscription": "Subscriptions", "Media": "Media", "Signal": "Verification signals", "Location": "Locations", "Activity": "Walker activity (ran)", "Investigation": "Report investigations"};
  return _jac.dict.get(titles, kind, kind);
}
function kind_order() {
  return ["Incident", "Person", "IdentityDecision", "Claim", "Source", "Organization", "Alert", "Subscription", "Media", "Signal", "Location", "Investigation", "Activity"];
}
function edge_phrase(kind) {
  let phrases = {"Involves": "involves", "Contains": "contains", "Asserts": "asserts", "About": "is about", "SupportedBy": "is supported by", "Depicts": "depicts", "LocatedAt": "is located at", "HasSignal": "has signal", "HasSubscription": "has subscription", "Receives": "receives", "Triggered": "triggered", "ClaimRef": "is named as the cause of", "HasOrganization": "has publisher", "Publishes": "publishes", "Reviews": "reviews", "ExactCopyOf": "is an exact copy of", "DuplicateCandidate": "may be the same person as", "Touched": "touched", "HasInvestigation": "has investigation", "InvestigationCitation": "cites"};
  return _jac.dict.get(phrases, kind, kind);
}
function badge_tone(badge) {
  if ((badge === "stored")) {
    return "border-border bg-muted text-foreground";
  }
  if ((badge === "confirmed")) {
    return "border-status-safe/40 bg-status-safe-soft text-status-safe";
  }
  if ((badge === "rejected")) {
    return "border-status-missing/40 bg-status-missing-soft text-status-missing";
  }
  if ((badge === "candidate")) {
    return "border-dashed border-status-warning/60 bg-status-warning-soft text-status-warning";
  }
  if ((badge === "derived")) {
    return "border-dashed border-primary/50 bg-primary/10 text-primary";
  }
  if ((badge === "simulated")) {
    return "border-status-warning/40 bg-status-warning-soft text-status-warning";
  }
  if ((badge === "walker ran")) {
    return "border-primary/40 bg-primary/10 text-primary";
  }
  return "border-border bg-muted/60 text-muted-foreground";
}
function kind_fill(kind) {
  let fills = {"Incident": "fill-graph-incident", "Person": "fill-graph-person", "IdentityDecision": "fill-graph-review", "Claim": "fill-graph-claim", "Source": "fill-graph-source", "Organization": "fill-graph-organization", "Alert": "fill-graph-alert", "Subscription": "fill-graph-subscription", "Media": "fill-graph-media", "Signal": "fill-graph-signal", "Location": "fill-graph-location", "Investigation": "fill-graph-investigation", "Activity": "fill-graph-activity"};
  return _jac.dict.get(fills, kind, "fill-muted-foreground");
}
function edge_stroke(status) {
  if ((status === "confirmed")) {
    return "stroke-status-safe";
  }
  if ((status === "rejected")) {
    return "stroke-status-missing";
  }
  if ((status === "candidate")) {
    return "stroke-status-warning";
  }
  if ((status === "derived")) {
    return "stroke-primary";
  }
  return "stroke-muted-foreground";
}
function badge_hint(badge) {
  let hints = {"stored": "Persisted in the graph", "confirmed": "A person confirmed this link", "rejected": "A person rejected this link", "candidate": "Computed on read by ResolveWalker's rule; not stored, not confirmed", "derived": "Computed on read; not a stored edge", "simulated": "Demo stand-in, not a real check", "walker ran": "Recorded when a walker actually ran", "seed": "Created by the demo seed", "demo": "Fictional demo publisher, not an authenticated organization"};
  return _jac.dict.get(hints, badge, "");
}
function short_id(jid_value) {
  if ((jid_value.length <= 12)) {
    return jid_value;
  }
  return ((jid_value.slice(0, 6) + "...") + jid_value.slice((jid_value.length - 4)));
}
export {badge_hint, badge_tone, edge_phrase, edge_stroke, kind_fill, kind_order, kind_title, short_id};
//# sourceMappingURL=graph_helpers.js.map
